<template>
  <div class="psr">
    <div class="fy-width_100p fy-padding-t-100p tac quicksand" style="">
      <!-- <div class=" fy-width_50p  fy-padding-10">
        <div class=" fy-font-30  ">Inside</div>
      </div> -->
      <div
        class="fy-text-1  fy-margin-t-60 fy-padding-b-40 fy-light_b_bg2 fy-padding-t-40  fy-font-25"
        :class="{ 'disflex fy-flex_rve fy-padding-l-20': GETscreen === 'desktop' }"
      >
        <div
          class=" tac fy-brown "
          :class="{ ' fy-width_30p fy-br_l': GETscreen === 'desktop' }"
        >
          <div
            class="fy-margin-t-20 fy-font-30 fy-fs_i"
            :class="{ 'fy-margin-l-10': GETscreen === 'mobile' }"
          >
            <div
              class="fy-fit_width fy-padding-5 fy-padding-l-10 fy-padding-r-10 fy-border fy-border_r12"
              style="line-height:35px"
            >
              Grewtales
            </div>
          </div>
        </div>
        <div
          class=" fy-ts"
          :class="{
            'fy-width_70p ': GETscreen === 'desktop',
            'fy-width_100p fy-margin-t-20 fy-font-20': GETscreen === 'mobile'
          }"
        >
          Engage with your Friends, Family, Collegues, Competitors, Neighbors
          and Knowing in Competition with audio, video, text, image and more.
        </div>
      </div>
      <div
        class="fy-text-1  fy-padding-b-40 fy-padding-t-70  fy-light_b_bg fy-font-25"
        :class="{'fy-padding-l-20' : GETscreen === 'desktop'}"
      >
        <div
          class="fy-width_100p"
          :class="{ disflex: GETscreen === 'desktop' }"
        >
          <div
            class=" tac fy-brown "
            :class="{ ' fy-width_30p fy-br_r': GETscreen === 'desktop' }"
          >
            <div
              class="fy-margin-t-10 fy-font-30 fy-fs_i"
              :class="{ 'fy-margin-l-10 fy-margin-r-10': GETscreen === 'mobile' }"
            >
              <div
                class="fy-fit_width fy-padding-5 fy-padding-l-10 fy-padding-r-10 fy-border fy-border_r12"
                style="line-height:35px"
                :class="{'fy-margin-r-15' : GETscreen === 'desktop' }"
              >
                Measurable socio-plotting
              </div>
            </div>
          </div>
          <div
            class=" fy-ts"
            :class="{
              'fy-width_70p fy-padding-l-50': GETscreen === 'desktop',
              'fy-width_100p fy-margin-t-20 fy-font-20': GETscreen === 'mobile'
            }"
          >
            Plot for others and earn the things that have a meaningful impact on society. 
          </div>
        </div>
        <div v-observe-visibility="visibilityChanged" class="fy-width_100p tac">
          <div
            v-if="visible === true"
            class="fy-margin-t-10 "
            :class="{
              'disflex fy-flex_wrap fy-word_break fy-width_100p':
                GETscreen === 'desktop',
              'fy-fit_width': GETscreen === 'mobile'
            }"
          >
            <div
              v-for="(p, i) in getplotters"
              :key="i"
              class="disflex fy-margin-t-10 fy-height_40px"
              :class="{ 'fy-margin-l-15': GETscreen === 'desktop' }"
            >
              <div class="">
                <img
                  :src="GETbaseurl + `img/media/plotters/` + p.sub + `.svg`"
                  class="fy-width_40px fy-height_40px"
                />
              </div>
              <div
                class="fy-margin-t-10 fy-font-20 fy-ts fy-margin-l-10 fy-text-1"
              >
                {{ p.sub }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="fy-text-1  fy-padding-b-40 fy-light_b_bg2  fy-padding-t-70  fy-font-25"
        :class="{ 'disflex fy-padding-l-20 fy-flex_rve': GETscreen === 'desktop' }"
      >
        <div
          class=" tac fy-brown"
          :class="{ 'fy-width_30p fy-br_l': GETscreen === 'desktop' }"
        >
          <div class="fy-margin-t-20 fy-font-30 fy-fs_i">
            <div
              class="fy-fit_width fy-padding-5 fy-padding-l-10 fy-padding-r-10 fy-border fy-border_r12"
              style="line-height:35px"
            >
              Lifeline
            </div>
          </div>
        </div>
        <div
          id="yu"
          class=" fy-ts"
          :class="{
            'fy-width_70p ': GETscreen === 'desktop',
            'fy-width_100p fy-margin-t-20 fy-font-20': GETscreen === 'mobile'
          }"
        >
          Motivate, inspire and support others with your past, present and
          future and get admired, advantage and applause.
        </div>
      </div>

      <div
        class="fy-text-1  fy-padding-b-40 fy-light_b_bg fy-padding-t-70  fy-font-25"
        :class="{ 'fy-padding-l-20 disflex ': GETscreen === 'desktop' }"
      >
        <div
          class=" tac fy-brown "
          :class="{ 'fy-width_30p fy-br_r': GETscreen === 'desktop' }"
        >
          <div class="fy-margin-t-10 fy-font-30 fy-fs_i">
            <div
              class="fy-fit_width fy-padding-5 fy-padding-l-10 fy-padding-r-10 fy-border fy-border_r12"
              style="line-height:35px"
            >
              Dictionary
            </div>
          </div>
        </div>
        <div
          class=" fy-ts"
          :class="{
            'fy-width_70p fy-padding-l-50': GETscreen === 'desktop',
            'fy-width_100p fy-margin-t-20 fy-font-20': GETscreen === 'mobile'
          }"
        >
          Share Word, Expertise and Interest in your dictionary to be more precise.
        </div>
      </div>
    </div>
    <basicInformation class="psa  fy-left_0" style="bottom:-45px"/>
  </div>
</template>
<style scoped>
.fy-brown {
  color: rgb(65 86 133);
}
.fy-light_b_bg {
  background: white;
}
.fy-light_b_bg2 {
  background: #5050501f;
}
.fy-br_r {
  border-right: 3px solid var(--fy-space-rve-50);
}
.fy-br_l {
  border-left: 3px solid var(--fy-space-rve-50);
}
</style>
<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      visible: false
    };
  },
  computed: {
    ...mapGetters(["GETscreen", "getplotters", "GETbaseurl", "GETencrypt"])
  },
  methods: {
    visibilityChanged(entry) {
      if (entry === true && this.visible === false) {
        this.visible = true;
        this.actions();
      }
    },
    actions() {
      const t = document.getElementById("ipss_0");
      if (t === null) {
        for (let i = 0; i < this.getplotters.length; i++) {
          var id = "ipss_" + i;
          var link = document.createElement("link");
          link.rel = "preload";
          link.id = id;
          var p =
            this.GETbaseurl +
            "img/media/plotters/" +
            this.getplotters[i].sub +
            ".svg";

          link.href = p;
          link.as = "image";
          link.setAttribute("data", this.GETencrypt.data);
          link.setAttribute("nonce", this.GETencrypt.nonce);
          document.head.appendChild(link);
        }
      }
    }
  }
};
</script>
